import React from 'react'
import paperjs from 'paper'
import * as PIXI from 'pixi.js'
import NoiseFilter from './util/noise-filter'
import { transformStops } from './util'
import { canvasRGB } from 'stackblur-canvas'

const realWidth = 120
const width = 400
const height = 400
const space = width / 5

export default class Ramp extends React.Component {
  componentDidMount() {
    if (typeof this.props.content === 'string') {
      this.setupColor()
    } else {
      this.setupTheme()
    }
  }

  setupColor = () => {
    const gradientPaper = new paperjs.PaperScope()
    const gradient = new gradientPaper.Path.Rectangle({
      topLeft: [-space, -space],
      bottomRight: [width + space, height + space],
      fillColor: this.props.content,
    })
    this.app = new PIXI.Application(realWidth, height, {
      view: this.pixiCanvas,
    })
    const gradientSprite = new PIXI.Sprite(
      PIXI.Texture.from(this.gradientCanvas),
    )
    gradientSprite.x -= 5
    gradientSprite.y -= 5
    this.app.stage.addChild(gradientSprite)
  }

  setupTheme = () => {
    // Gradient
    const gradientPaper = new paperjs.PaperScope()
    gradientPaper.setup(this.gradientCanvas)
    const gradient = new gradientPaper.Path.Rectangle({
      topLeft: [-space, -space],
      bottomRight: [width + space, height + space],
      fillColor: {
        gradient: {
          stops: transformStops(this.props.content.gradient.stops),
        },
        origin: [
          -width * (this.props.content.gradient.scale - 0.5),
          -height * (this.props.content.gradient.scale - 0.5),
        ],
        destination: [
          width * this.props.content.gradient.scale,
          height * this.props.content.gradient.scale,
        ],
      },
    })
    gradient.rotate(this.props.content.gradient.rotation + 135)

    // Wave
    const wavePaper = new paperjs.PaperScope()
    wavePaper.setup(this.waveCanvas)
    let wave
    if (this.props.content.wave.enabled) {
      wave = new wavePaper.Path.Rectangle({
        topLeft: [-space, -space],
        bottomRight: [width + space, height + space],
        fillColor: {
          gradient: {
            stops: transformStops(this.props.content.wave.stops),
          },
          origin: [
            -width * (this.props.content.wave.scale - 1),
            -height * (this.props.content.wave.scale - 1),
          ],
          destination: [
            width * this.props.content.wave.scale,
            height * this.props.content.wave.scale,
          ],
        },
      })
      wave.rotate(this.props.content.wave.rotation)
    }

    // Displacement
    this.app = new PIXI.Application(realWidth, height, {
      view: this.pixiCanvas,
    })
    const gradientSprite = new PIXI.Sprite(
      PIXI.Texture.from(this.gradientCanvas),
    )
    gradientSprite.x -= 5
    gradientSprite.y -= 5
    this.app.stage.addChild(gradientSprite)

    const waveSprite = new PIXI.Sprite(PIXI.Texture.from(this.waveCanvas))
    const displacementFilter = new PIXI.filters.DisplacementFilter(waveSprite)
    displacementFilter.scale.x = this.props.content.wave.intensity
    displacementFilter.scale.y = this.props.content.wave.intensity
    const noiseFilter = NoiseFilter()
    noiseFilter.uniforms.opacity = this.props.content.sparkle.opacity
    noiseFilter.uniforms.scale = this.props.content.sparkle.scale * 10

    // Sparkle
    gradientSprite.filters = [
      this.props.content.wave.enabled && displacementFilter,
      this.props.content.sparkle.enabled && noiseFilter,
    ]

    // Animate
    this.app.ticker.add((d, b) => {
      gradient.fillColor.gradient.stops.forEach(stop => {
        stop.offset =
          (stop.offset += this.props.content.gradient.speed * 0.001) % 1.0
      })
      // canvasRGB(this.gradientCanvas, 0, 0, width + space, height + space, 10);
      gradientSprite.texture.update()
      if (this.props.content.wave.enabled) {
        wave.fillColor.gradient.stops.forEach(stop => {
          stop.offset = (stop.offset += this.props.content.wave.speed) % 1.0
        })
        canvasRGB(this.waveCanvas, 0, 0, width, height, 150)
        waveSprite.texture.update()
      }
      if (this.props.content.sparkle.enabled) {
        noiseFilter.uniforms.translate +=
          0.004 * this.props.content.sparkle.speed
      }
    })
  }

  componentWillUnmount() {
    this.app.destroy()
  }

  render() {
    return (
      <div>
        <canvas
          style={{ overflow: 'hidden' }}
          width={realWidth}
          height={height}
          ref={c => (this.pixiCanvas = c)}
        />
        <div hidden>
          <canvas
            width={width + space}
            height={height + space}
            ref={c => (this.gradientCanvas = c)}
          />
          <canvas
            width={width}
            height={height}
            ref={c => (this.waveCanvas = c)}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ramp/index.js